

import React from 'react';
import get from 'lodash/get';
import { Contact } from 'src/stores/account-store';

const clsPrefix = 'app-request-access-contact-card';

interface ContactCardProps {
  label: string;
  agent: Contact;
}

const ContactCard: React.FC<ContactCardProps> = (props) => {
  const { label, agent } = props;
  return (
    <div className={`flex-cols flex-align-center margin-right-sm ${clsPrefix}`}>
      <span className="uppercase">{label}</span>
      <span className="bold">
        {agent.firstName} {agent.lastName}
      </span>
      <a className={`${clsPrefix}__email`} href={`mailto:${agent.email}`}>
        {agent.email}
      </a>
      <span>{agent.cellPhone}</span>
      {get(agent, 'reAgent.licenseNumber') && (
        <span>
          {agent.reAgent.licenseState}#{agent.reAgent.licenseNumber}
        </span>
      )}
    </div>
  );
};

export default ContactCard;
